import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-header" }
const _hoisted_2 = { class: "dashboard-left" }
const _hoisted_3 = { class: "dashboard-title" }
const _hoisted_4 = { class: "dashboard-subtitle" }
const _hoisted_5 = { class: "dashboard-actions" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mr-2 is-size-4 mdi-arrow-left" }, null, -1 /* HOISTED */)
const _hoisted_7 = { class: "has-first-letter-uppercase mr-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mr-2 is-size-4 mdi-restore" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "has-first-letter-uppercase mr-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mr-2 is-size-4 mdi-plus" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "has-first-letter-uppercase mr-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mr-2 is-size-4 mdi-check" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "has-first-letter-uppercase mr-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('dashboard_edit.title')), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('dashboard_edit.description')), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, { to: {name: 'dashboard'} }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            class: "mr-1",
            round: "",
            size: "large"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('global.cancel')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dashboard-edit:reset'))),
        class: "mr-1",
        round: "",
        size: "large"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('dashboard_edit.restore')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dashboard-edit:add-widget'))),
        class: "mr-1",
        round: "",
        size: "large"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('dashboard_edit.select_widget.title')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('dashboard-edit:submit'))),
        class: "mr-1",
        type: "primary",
        round: "",
        size: "large"
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.header.validate')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}